
import React, { useContext, useState } from 'react'

const InspectionsContext = React.createContext()
const { Provider } = InspectionsContext

const defaultInspectionsState =
{
	vehicleInspectionPictures: [],
	vehicleLocation:
	{
		address1: '',
		address2: '',
		areaCode: '',
		city: '',
		contactName: '',
		extension: '',
		fax: '',
		locationName: '',
		phone2: '',
		phoneNumber: '',
		state: '',
		zipCode: ''
	},
	vehicleInspectionDamages: [],
	vehicleInspectionTires: [],
	vehicleInspection: {
		vehicleInspectionId: undefined,
		vehicleId: undefined,
		airBagLight: undefined,
		auctionBuyPrice: undefined,
		auctionReservePrice: undefined,
		auctionStartPrice: undefined,
		bodyStyleName: undefined,
		checkEngineLight: undefined,
		conditionType: undefined,
		consignor: undefined,
		country: undefined,
		currencyId: undefined,
		cylinders: undefined,
		displacement: undefined,
		doors: undefined,
		drivetrain: undefined,
		engineName: undefined,
		expectedGroundingDate: undefined,
		exteriorColor: undefined,
		frameDamage: undefined,
		fuelType: undefined,
		inspectionDate: undefined,
		inspectionId: undefined,
		inspectionMileage: undefined,
		inspectionType: undefined,
		interiorColor: undefined,
		interiorType: undefined,
		lastMaintenanceDate: undefined,
		license: undefined,
		makeName: undefined,
		mileageUOM: undefined,
		modelName: undefined,
		odometerCondition: undefined,
		overallCondition: undefined,
		pictureReference: undefined,
		rateGeneral: undefined,
		rateMech: undefined,
		rateMetal: undefined,
		ratePaint: undefined,
		ratePdr: undefined,
		registrationExpireDate: undefined,
		registrationState: undefined,
		registrationPostal: undefined,
		roofType: undefined,
		sellerModelCode: undefined,
		sellerVehicleCode: undefined,
		seriesName: undefined,
		smokedIn: undefined,
		speeds: undefined,
		statusCode: undefined,
		statusDate: undefined,
		statusDescription: undefined,
		styleId: undefined,
		styleName: undefined,
		transmission: undefined,
		turbo: undefined,
		serialNumber: undefined,
		vehicleGrade: undefined,
		wasTestDriven: undefined,
		year: undefined,
		created: undefined,
		lastActivity: undefined,
		updateBy: undefined,
		vehicleInspectionDamages: [],
		vehicleInspectionPictures: []
	}
}

const InspectionsProvider = (props) =>
{
	const [vehicleInspectionPictures, setVehicleInspectionPictures] = useState(defaultInspectionsState.vehicleInspectionPictures)
	const [vehicleLocation, setVehicleLocation] = useState(defaultInspectionsState.vehicleLocation)
	const [vehicleInspectionDamages, setVehicleInspectionDamages] = useState(defaultInspectionsState.vehicleInspectionDamages)
	const [vehicleInspection, setVehicleInspection] = useState(defaultInspectionsState.vehicleInspection)
	const [vehicleInspectionTires, setVehicleInspectionTires] = useState(defaultInspectionsState.vehicleInspectionTires)

	return <Provider value={{
		vehicleInspectionPictures,
		setVehicleInspectionPictures,
		vehicleLocation,
		setVehicleLocation,
		vehicleInspectionDamages,
		setVehicleInspectionDamages,
		vehicleInspection,
		setVehicleInspection,
		vehicleInspectionTires,
		setVehicleInspectionTires
	}}>
		{ props.children }
	</Provider>
}

export { InspectionsProvider, InspectionsContext }
